const Players = {
    NAME: "players",
    TABLE: "tableId"
}

const Seats = {
    NAME: "seats",
    TABLE: "tableId",
    PLAYER: "playerID",
    NUMBER: "number"
}

const Tables = {
    NAME: "tables",
}

const Hands = {
    NAME: "hands",
    PLAYER: "playerId",
}

const Messages = {
    NAME: "messages",
    TABLE_ID: "tableId",
    PLAYER_ID: "playerId",
    MESSAGE: "message",
}

export {Players, Seats, Tables, Hands, Messages}
